module.exports = __webpack_public_path__ + "static/media/ProximaNovaACond-Semibold.3e12fcf7.woff2";